import countriesJSON from '../json/countries.json'

export const mapCountriesJSONtoOptions = () => (countriesJSON
    .map(({ name: text, code: value }) => ({ text, value }))
)